module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/miami-university-e0037cf82b5d30e83b6a0f8d49170539.jpg";